module.exports = __webpack_public_path__ + "static/media/hvammsvirkjunB&A.14d953a7.mp4";